function Aggregator_form_edit(element) {
  this.$element = $(element);
  this.popup = i4_Popup.get(this.$element);

  this.selectors = {
    formParent: 'form[data-i4-decorator="Validator_form"]',
    buttonNext: '.js-button-next',
    buttonSave: '.js-button-save',
    buttonPaste: '.js-button-paste',
  };

  this.data = {
    pluginNext: 'plugin-next',
    pluginSave: 'plugin-save',
    pluginVariants: 'plugin-variants',
    ajaxUrl: 'ajax-url',
    pluginName: 'plugin-name',
    instanceId: 'instance-id',
    containerId: 'container-id',
    sequence: 'sequence',
    url: 'url'
  };

  this.triggers = {
    afterLoaded: 'i4:afterLoaded'
  };

  this.init = function () {
    this.$formParent = this.$element.parents(this.selectors.formParent);
    this.$buttonNext = this.$element.find(this.selectors.buttonNext);
    this.$buttonSave = this.$element.find(this.selectors.buttonSave);
    this.$buttonPaste = this.$element.find(this.selectors.buttonPaste);
    // this.$selectPlugin = this.$element.find(this.selectors.selectPlugin);

    this.dataPluginNext = this.$element.data(this.data.pluginNext);
    this.$pluginNext = $(this.dataPluginNext);
    this.dataPluginSave = this.$element.data(this.data.pluginSave);
    this.$pluginSave = $(this.dataPluginSave);
    this.dataPluginVariants = this.$element.data(this.data.pluginVariants);
    this.$pluginVariants = $(this.dataPluginVariants);

    this.dataAjaxUrl = this.$element.data(this.data.ajaxUrl);
    this.dataPluginName = this.$element.data(this.data.pluginName);
    this.dataInstanceId = this.$element.data(this.data.instanceId);
    this.dataContainerId = this.$element.data(this.data.containerId);
    this.dataSequence = this.$element.data(this.data.sequence);
    this.dataUrl = this.$element.data(this.data.url);

    this.$buttonNext.on('click', this.$onClickNext.bind(this));
    this.$buttonSave.on('click', this.$onClickSave.bind(this));
    this.$buttonPaste.on('click', this.$onClickPaste.bind(this));

    // not accessible with css. the "Insert New Element" dialog is the only popup where i4-popup__content has zero padding
    const popup_content = this.$element.closest('.i4-popup__content');
    popup_content.css('padding', 0);
  };

  this.$onChangePlugin = function () {
    this.updateView();
  };

  this.$onClickNext = function (event) {
    event.preventDefault();
    let pluginId = $(event.target).val();

    i4_Document_listener.set_click_position({
      top: event.pageY,
      left: event.pageX
    });

    let variantId = 0;
    this.$pluginVariants.each((function(i, item) {
      if (pluginId == item.variant){
        variantId = pluginId;
        pluginId = item.plugin;
      }
    }).bind(this));

    i4_Popup.add().
    set_option({
      ajax_param: {
        js: this.dataPluginName,
        call: 'new_content',
        aggregator_id: this.dataInstanceId,
        container_id: this.dataContainerId,
        sequence: this.dataSequence,
        plugin_id: pluginId,
        variant_id: variantId
      },
      position: this.popup
    }).
    add_callback('after_loaded', (function (popup) {
        var $popup = $('#' + popup.id_name);

        $popup.find('input[name=do]').val('Aggregator');
        $popup.find('input[name=action]').val('insert_content');

        $popup.find('button[type=submit]').first().
        after(
          $('<input>').attr({
            type: 'hidden',
            name: 'aggregator_container_id',
            value: this.dataContainerId
          })
        ).
        after(
          $('<input>').attr({
            type: 'hidden',
            name: 'aggregator_plugin_id',
            value: pluginId
          })
        ).
        after(
          $('<input>').attr({
            type: 'hidden',
            name: 'aggregator_id',
            value: this.dataInstanceId
          })
        ).
        after(
          $('<input>').attr({
            type: 'hidden',
            name: 'sequence',
            value: this.dataSequence
          })
        ).
        after(
          $('<input>').attr({
            type: 'hidden',
            name: 'plugin_variant',
            value: this.variant
          })
        );

        const svgElem = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        const titleElem = document.createElementNS('http://www.w3.org/2000/svg', 'title');
        const useElem = document.createElementNS('http://www.w3.org/2000/svg', 'use');

        titleElem.innerHTML = i4_Translation.get().back;
        useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#svg-sprite-admin-arrow-back');
        svgElem.appendChild(titleElem);
        svgElem.appendChild(useElem);

        $popup.find('button.close_popup').before(
          $('<button></button>').attr({
            type: 'button'
          }).addClass('i4-button i4-button-back').html(svgElem).on('click', (function () {
            this.popup.show();
            popup.remove();
          }).bind(this))
        );

      }).bind(this))
      .run();

    this.popup.hide();
  };

  this.$onClickSave = function (event) {
    event.preventDefault();
    this.pluginId = $(event.target).val();
    const form = $(event.target).parents('form').first();

    this.pluginVariant = false;
  	this.$pluginVariants.each((function(i, item) {
  		if (this.pluginId == item.variant){
  			this.pluginVariant = item.plugin;
  		}
    }).bind(this));

    const hidden_plugin_variant = $('input[name=plugin_variant]');
    const hidden_plugin = $('input[name=plugin]');
    if ($(hidden_plugin_variant).length > 0) {
      $(hidden_plugin_variant).remove();
    }
    if ($(hidden_plugin).length > 0) {
      $(hidden_plugin).remove();
    }

    if (this.pluginVariant) {
      $(form).append('<input type="hidden" name="plugin_variant" value="' + this.pluginId + '">');
      $(form).append('<input type="hidden" name="plugin" value="' + this.pluginVariant + '">');
  	} else {
  		$(form).append('<input type="hidden" name="plugin" value="' + this.pluginId + '">');
  	}

    form.submit();
  };

  this.$onClickPaste = function (event) {
    event.preventDefault();
    i4_Popup.add().set_option({
      ajax_param: JSON.parse(JSON.stringify({
        call: "paste",
        js: "Aggregator",
        aggregator_id: this.dataInstanceId,
        container_id: this.dataContainerId,
        sequence: this.dataSequence,
      })),
      position: 'cursor',
      loader: true
    }).
    add_callback('after_loaded', (function (popup) {
      var $popup = $('#' + popup.id_name);

      const svgElem = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      const titleElem = document.createElementNS('http://www.w3.org/2000/svg', 'title');
      const useElem = document.createElementNS('http://www.w3.org/2000/svg', 'use');

      titleElem.innerHTML = i4_Translation.get().back;
      useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#svg-sprite-admin-arrow-back');
      svgElem.appendChild(titleElem);
      svgElem.appendChild(useElem);

      $popup.find('button.close_popup').before(
        $('<button></button>').attr({
          type: 'button'
        }).addClass('i4-button i4-button-back').html(svgElem).on('click', (function () {
          this.popup.show();
          popup.remove();
        }).bind(this))
      );
    }).
    bind(this)).
    run();
    this.popup.hide();

  };

}
